import { forwardRef, useImperativeHandle } from "react";
import { Form } from "react-bootstrap";

function DeliveryPrice(props, ref) {

    useImperativeHandle(ref, () => ({
        getName: getName,
        getType: getType,
        getTitle: getTitle,
        hasSettings: hasSettings,
        getSettings: getSettings,
        getDefaultOptions: ({ createOrUpdate }) => ({})
    }));

    const getName = () => {
        return 'Договорена дост. цена';
    }

    const getType = () => {
        return 'delivery_price';
    }

    const getTitle = () => {
        return 'Договорена доставна цена с доставчика';
    }

    const hasSettings = () => false;

    const getSettings = ({ state, setConfig, createOrUpdate }) => {
        return null;
    }

    return getName();
}

export default forwardRef(DeliveryPrice)